import React,{useCallback, useEffect, useState} from 'react'
import { getAdmissionMode, getCurriculums,upadateProfileDetail, batchOptions } from '../../actions/StudentAction'
import { StateUseContext } from '../../context/UserDetailContext'
import { getCountries, getCities, getClasses, getSchools,getStudyCenter, getCourses, RegisterUser, } from '../../actions/RegisterAction';
import swal from 'sweetalert';
import Select from 'react-select'
import { countryId } from '../../config/Constant';
import { useNavigate } from 'react-router-dom';


const EnrollmentDetailForm = ({nexTabChange}) => {
    const navigate = useNavigate();
    const {userDetail,setUserDetail} = StateUseContext();
    const {is_paid,paid_status,batch_preference} = userDetail !==undefined && userDetail

    const [admissionMode,setAdmissionMode] = useState({value:'',options:[],error:''});
    const [country,setCountry] = useState({value:'',options:[],error:''})
    const [classes,setClasses] = useState({value:'',options:[],error:''})
    const [selectedCurriculum,setSelectedCurriculum] = useState({value:'',options:[],error:''})
    const [cities,setCities] = useState({value:'',options:[],error:''})
    const [otherCity,setOtherCity] = useState({value:'',error:''})
    const [schools, setSchools] = useState({value: '', options: [] , error: ''});
    const [otherSchoolName, setOtherSchoolName] = useState({ value: '', error: '' });
    const [isOtherSchool, setIsOtherSchool] = useState(false)
    const [courses, setCourses] = useState({ value: '', error: '', options: [] });
    const [studyCenter, setStudyCenter] = useState({ value: '', options: [],error: '' });
    const [showOtherCity,setShowOtherCity] = useState(false)
    const [otherCurriculum,setOtherCurriculum] = useState({value:'',error:''})
    const [showOtherCurriculum,setShowOtherCurriculum] = useState(false)
    const [loading,setLoading] = useState(false);

    const [batchPreference,setBatchPreference] = useState({value:'',error:''});
    const [batchOption,setBatchOption] = useState({value:'',optons:[],error:''});

// const admissionModeData = async() => {
//     await getAdmissionMode().then((res) => {
//         if(res.status){
//             setAdmissionMode({...admissionMode,options:res.data})
//         }
//     })
// }

const getUserCountry = async() => {
    try {
        const countryRes =  await getCountries();
        setCountry({ ...country, options: countryRes.data, 
        value:userDetail.country_id!==undefined?countryRes.data?.filter(i=>i.id==userDetail.country_id)[0]:{}
    })
    } catch (error) {
        console.log('country error...',error)
    }
}

const getUserCity = async() => {
    try {
        const citiesRes = await getCities(userDetail.country_id)
        setCities({ ...cities, options: citiesRes.data, value:userDetail.city_id!==undefined?citiesRes.data.filter(i=>i.id==userDetail.city_id)[0]:{} })
    } catch (error) {
        console.log('city error...',error)
    }
}
const getUserClass = async() => {
    try {
        const classesRes = await getClasses(userDetail.country_id)
        setClasses({ ...classes, options: classesRes.data,value:userDetail.class_id!==undefined?classesRes.data.filter(i=>i.id==userDetail.class_id)[0]:{}})
    
    } catch (error) {
        console.log('classes error...',error)
    }
}

const getUserStudyCenter = async() => {
    const centerRes = await getStudyCenter(userDetail.country_id)
    setStudyCenter({ ...studyCenter, options: centerRes.data,value:userDetail.center_id!==undefined?centerRes.data.filter(i=>i.id==userDetail.center_id)[0]:{}})
}

const getUserSchool = async() => {
    try {
        const schoolRes = await getSchools(userDetail.country_id)
        setSchools({ ...schools, options: schoolRes.data,value:userDetail.school_id!==undefined?schoolRes.data.filter(i=>i.id==userDetail.school_id)[0]:{}})
    
    } catch (error) {
        console.log('school error...',error)
    }
}

const getUserCurriculums = async() => {
    try {
        if(userDetail?.curriculum_name=="OTHER" || userDetail?.curriculum_name=="OTHERS"){
            const curriculumsRes = await getCurriculums(userDetail.country_id)
            setSelectedCurriculum({ ...selectedCurriculum, options: curriculumsRes.data,value:userDetail.curriculum_name!==undefined?curriculumsRes.data.filter(i=>i.name==userDetail.curriculum_name)[0]:{}})
        }
        else{
            const curriculumsRes = await getCurriculums(userDetail.country_id)
            setSelectedCurriculum({ ...selectedCurriculum, options: curriculumsRes.data,value:userDetail.curriculums_id!==undefined?curriculumsRes.data.filter(i=>i.id==userDetail.curriculums_id)[0]:{}})
        }
    
    } catch (error) {
        console.log('curriculum error...',error)
    }
}

const getUserCourse = async() => {
    try {
        const courseRes = await getCourses(userDetail.country_id, userDetail.class_id, userDetail?.center_id)
        setCourses({ ...courses, options: courseRes.data,value:userDetail.course_id!==undefined?courseRes.data.filter(i=>i.id==userDetail.course_id)[0]:{}})
    
    } catch (error) {
        console.log('course error...',error)
    }
}

const getBatchOptions = async() => {
    try {
        const batchOptionRes = await batchOptions(userDetail.country_id, userDetail.class_id, userDetail?.course_id)
        setBatchOption({ ...batchOption, options: batchOptionRes.data,value:userDetail.batch_option_id!==undefined?batchOptionRes.data.filter(i=>i.id==userDetail.batch_option_id)[0]:{}})
    
    } catch (error) {
        console.log('course error...',error)
    }
}



    useEffect(() => {

        if(userDetail !==undefined){
            // setAdmissionMode({...admissionMode,value:userDetail.admission_mode_id})
            setClasses({...classes,value:userDetail?.class_id})
            setCountry({...country,value:userDetail!==undefined && userDetail.country_id})
            setCities({...cities,value:userDetail.city_id})
            setOtherCity({...otherCity,value:userDetail.other_city})
            setStudyCenter({...studyCenter,value:userDetail.center_id})
            setCourses({...courses,value:userDetail.course_id})
            setSchools({...schools,value:userDetail.school_id})
            setSelectedCurriculum({...selectedCurriculum,value:userDetail?.curriculums_id})
            setOtherCurriculum({...otherCurriculum,value:userDetail.other_curriculum})
            setOtherSchoolName({...otherSchoolName,value:userDetail.other_school})
            setBatchOption({...batchOption,value:userDetail.batch_option_id})
            setBatchPreference({...batchPreference,value:batch_preference})
        }

        // admissionModeData();
        getUserCountry()
        getUserCity()
        getUserClass()
        getUserStudyCenter()
        getUserCourse()
        getUserSchool()
        getUserCurriculums()
        getBatchOptions()

    },[userDetail.class_id,userDetail.country_id,userDetail.city_id,userDetail.other_city,userDetail.center_id,userDetail.course_id,userDetail.school_id,
        userDetail.curriculums_id,userDetail.other_school])

    useEffect(() => {
        if(schools.value?.id === 0){
            setIsOtherSchool(true)
        }
        if(cities.value?.id === 0){
            setShowOtherCity(true)
        }
        if(selectedCurriculum.value?.name =='OTHER' || selectedCurriculum.value?.name =='OTHERS' || userDetail?.curriculum_name=="OTHER"){
            setShowOtherCurriculum(true)
        }
    },[schools])


    const countryChangeHandler = async(e) => {
        setCountry({...country, value:e, error:''})
        setOtherCity({...otherCity,value:'',error:''})
        setBatchPreference({...batchPreference,value:'',error:''})
        setBatchOption({ ...batchOption, value:'', error: '' })
        setShowOtherCity(false)
        setOtherSchoolName({...otherCity,value:'',error:''})
        setIsOtherSchool(false)
        
            try {
                await getCities(e.id).then((res) => {
                    if(res.status){
                        setCities({...cities,options:res.data,value:res.data.length==1?res.data[0]:''})
                    }
                })
            } catch (error) {
                console.log(error)
            }
            // Schools
            try {
              await  getSchools(e.id)
                .then((res) => {
                    setSchools({ ...schools, options:res.data,value:res.data.length==1?res.data[0]:''})
                });
            } catch (error) {
                console.log('schools..',error)
            }

            // Study Center
            try {
                await getStudyCenter(e.id).then((res) => {
                    setStudyCenter({ ...studyCenter, options: res.data,value:''})
                });
        
            } catch (error) {
                console.log('study center...',error)
            }

            try {
                const courseRes=await getCourses(e.id,classes.value,studyCenter.value.id)
                setCourses({ ...courses, options: courseRes.data,value:''})
            } catch (error) {
                console.log('courses...',error)
            } 
            
            try {
                const batchOptionRes = await batchOptions(e.id,classes.value.id,courses.value?.id)
                setBatchOption({ ...batchOption, options: batchOptionRes.data,value:''})
            } catch (error) {
                console.log('batchoption...',error)
            }  
            
          
            
    }

    const handleClassChange = (e) => {
        setBatchOption({ ...batchOption, value:'', error: '' })
        if(userDetail?.txo_class_id > 0){
            swal({
                title: "Wait A Second!",
                text: "Are you certain about updating the class ? Please be aware that if you proceed, the scholarship will no longer be applicable.",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                
              }).then((willDelete) => {
                if (willDelete) {
                    setClasses({ ...classes, value: e, error: '' });
                    getCourses(country.value.id,e.id,studyCenter.value.id)
                    .then((res) => {
                        setCourses({ ...courses, options: res.data,value:''   })
                    });

                    
                    batchOptions(country.value.id,e.id,courses.value.id).then((res) => {
                        setBatchOption({ ...batchOption, options: res.data,value:''})
                    });
                   
                    
                  swal("The class has been updated successfully.", {
                    icon: "success",
                  });
                } 
              });
        }
        else{
            setClasses({ ...classes, value: e, error: '' });
            getCourses(country.value.id,e.id,studyCenter.value.id)
            .then((res) => {
                setCourses({ ...courses, options: res.data,value:''   })
            });

            batchOptions(country.value.id,e.id,courses.value?.id).then((res) => {
                setBatchOption({ ...batchOption, options: res.data,value:''})
            });
        }
   
    }

    
    const cityChangeHandler = (e) => {
        const cVal = e.id;
        setCities({...cities,value:e,error:''})
        setOtherCity({...otherCity,value:'',error:''})
        if(cVal ===0){
            setShowOtherCity(true)
        }
        else{
            setShowOtherCity(false)
        }
    }

    const handleSchoolChange = (e) => {
        const sVal = e.id
        setSchools({ ...schools, value: e, error: '' });
        setOtherSchoolName({ ...otherSchoolName, value: '', error: '' })
        if (sVal == 0) {
            setIsOtherSchool(true)
        }
        else {
            setIsOtherSchool(false)
        }

    }

    const handleStudyCenterChange = (e) => {
        setStudyCenter({ ...studyCenter, value: e, error: '' });
        setCourses({ ...courses,  error: '' });
        try {
            getCourses(country.value.id,classes.value.id,e.id)
            .then((res) => {
                setCourses({ ...courses, options:res.data,value:''  })
            });
        } catch (error) {
            console.log('course error',error)
        }
    }

    const handleCoursesChange = (e) => {
        setCourses({ ...courses, value: e, error: '' });
        setBatchOption({ ...batchOption, value:'', error: '' })
        batchOptions(country.value.id,classes.value.id,e.id).then((res) => {
            setBatchOption({ ...batchOption, options: res.data,value:''})
        });
    }

    const handleBatchOptionChange = (e) => {
        setBatchOption({ ...batchOption, value: e, error: ''})
    }





    const handleCurriculumChange = (e) => {
        let currVal = e.name;
   
        setSelectedCurriculum({ ...selectedCurriculum, value: e, error: '' })
        setOtherCurriculum({ ...otherCurriculum, value: '', error: '' })
        if (currVal =='OTHER' || currVal =='OTHERS') {
            setShowOtherCurriculum(true)
        }
        else {
            setShowOtherCurriculum(false)
        }
    }

    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        let formIsValid = true

        if (!country.value) {
            formIsValid = false
            let msg = "Please select country"
            setCountry({ ...country, error: msg })
        }

        if (!studyCenter.value) {
            formIsValid = false
            let msg = "Please select study center"
            setStudyCenter({ ...studyCenter, error: msg })
        }



        if(country.value.id ===1 || country.value.id ===2 || country.value.id ===5 || country.value.id ===7 || country.value.id ===4) {
            if(classes.value.id ===1 || classes.value.id ===2){
                if (!batchOption.value) {
                    formIsValid = false
                    let msg = "Please select batch option"
                    setBatchOption({ ...batchOption, error: msg })
                }
            }
        }
               
        
        

        if (!courses.value || courses.value==undefined) {
            formIsValid = false
            let msg = "Please select course"
            setCourses({...courses, error: msg })
        }

        if (!selectedCurriculum.value || selectedCurriculum.value =='' || selectedCurriculum.value ==undefined) {
            formIsValid = false
            let msg = "Please select curriculum"
            setSelectedCurriculum({ ...selectedCurriculum, error: msg })
        }

        if (selectedCurriculum.value?.name=='OTHER' || selectedCurriculum.value?.name=='OTHERS') {
            formIsValid = true
            setSelectedCurriculum({ ...selectedCurriculum, error: '' })
            if(!otherCurriculum.value){
                formIsValid = false
                setOtherCurriculum({...otherCurriculum,error:'Please provide other curriculum name'})
            }

        }

        if (!cities.value) {
            formIsValid = false
            let msg = "Please select city"
            setCities({ ...cities, error: msg })
        }
        if(cities.value ===0){
            formIsValid = false
            let msg = "Please enter other city name"
            setOtherCity({ ...otherCity, error: msg })
        }

        if (cities.value?.id == 0) {
            formIsValid = true
            setCities({ ...cities, error: '' })
            if (!otherCity.value) {
                formIsValid = false
                setOtherCity({ ...otherCity, error: 'Please provide other city name' })
            }

            if (otherCity.value !== '' && otherCity.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length"
                setOtherCity({ ...otherCity, error: msg })
            }
            else if (otherCity.value !== '' && otherCity.value.length >= 50) {
                formIsValid = false
                let msg = "Max 50 Character Length"
                setOtherCity({ ...otherCity, error: msg })
            }
        }

        if (!classes.value) {
            formIsValid = false
            let msg = "Please select class"
            setClasses({ ...classes, error: msg })
        }

        if(!schools.value){
            formIsValid = false
            let msg = "Please select school"
            setSchools({...schools,error:msg})
        }

         // School
         if (schools.value?.id==0) {
            formIsValid = true
            setSchools({ ...schools, error: '' })
                if(!otherSchoolName.value){
                    formIsValid = false
                    setOtherSchoolName({...otherSchoolName,error:'Please provide other school name'})
                }

                 // Other school
            if (otherSchoolName.value !== '' && otherSchoolName.value.length < 3) {
                formIsValid = false
                let msg = "Min 3 Character Length"
                setOtherSchoolName({ ...otherSchoolName, error: msg })
            }
            else if (otherSchoolName.value !== '' && otherSchoolName.value.length >= 50) {
                formIsValid = false
                let msg = "Max 50 Character Length"
                setOtherSchoolName({ ...otherSchoolName, error: msg })
            }
        }

        // Batch preference
        if(country.value.id == 4){
            if(!batchPreference.value){
                formIsValid = false
                let msg = "Please select batch"
                setBatchPreference({...batchPreference,error:msg})
            }
        }
        
            if(formIsValid){
                setClasses({...classes,error:''})
                setCountry({...country,error:''})
                setCities({...cities,error:''})
                setOtherCity({...otherCity,error:''})
                setSchools({...schools,error:''})
                setOtherSchoolName({...otherSchoolName,error:''})
                setOtherCurriculum({...otherCurriculum,error:''})
                setStudyCenter({...studyCenter, error: '' })
                setSelectedCurriculum({...selectedCurriculum,error:''})
                setCourses({...courses, error: '' })
                setBatchPreference({...batchPreference,error:''})
                setBatchOption({ ...batchOption, error: '' })
            }

            return formIsValid;

    }

    // console.log('cities...',cities.value.id)

    const submitFormHandler = async(e) => {
        e.preventDefault();
        if(validation()){
            setLoading(true)
            const data = {
                id:userDetail?.id,
                // admission_mode_id:admissionMode.value,
                class_id:classes.value.id,
                country_id:country.value.id,
                city_id:cities.value.id,
                other_city:otherCity.value || '',
                center_id:studyCenter.value.id,
                course_id:courses.value.id,
                curriculums_id:selectedCurriculum.value.id,
                school_id:schools.value.id,
                other_school:otherSchoolName.value || '',
                other_curriculum:otherCurriculum.value || '',
                batch_preference:batchPreference.value || '',
                batch_option_id:batchOption.value?.id || ''
            }



            try {
                await upadateProfileDetail(data).then((res) => {
                    if(res.status){
                        setLoading(false)
                        setUserDetail({...userDetail,...res?.data})
                        swal(res?.message,'','success').then(() => {
                            nexTabChange()
                            
                        })

                        
                    }
                    else{
                        setLoading(false)
                        swal(res?.message,'','error')
                    }
                })
            } catch (error) {
                setLoading(false)
                console.log('update profile..',error)
            }

        }
    }

  
  return (
    <form onSubmit={submitFormHandler}>
        <div className="row mt-3 gx-lg-4">

            {/* <div className="col-md-6 mb-3">
                <label className="form-label d-block">Admission Mode</label>
                <select className="form-control" value={admissionMode.value || ''} onChange={e => setAdmissionMode({...admissionMode,value:e.target.value,error:''})}>
                    <option value="">Select Admission Mode</option>
                    {admissionMode.options?.map((item) => (
                        <option value={item.id} key={item.id}>{item.name}</option>
                    ))}
                </select>   
            </div> */}
             <div className="col-md-6 mb-3">
                <div className="row gx-3">
                    <div className="col-lg-6">
                        <label className="form-label">Country<span>*</span></label>
                        <Select
                            className='search-select-dropdown'
                            name="country"
                            value={country.value}
                            isDisabled={is_paid ===1 || paid_status===1}
                            placeholder="Select Country"
                            options={country.options}
                            onChange={countryChangeHandler}
                            getOptionLabel={x => x.name}
                            getOptionValue={x => x.id}
                        />
                        {country?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{country.error}</small>}

                    </div>

                    <div className="col-lg-6 mt-3 mt-lg-0">
                        <label className="form-label">City<span>*</span></label>
                        <Select
                            className='search-select-dropdown'
                            name="cities"
                            value={cities.value}
                            // isDisabled={is_paid ===1 || paid_status===1}
                            placeholder={`${country.value?.id &&country.value?.id === countryId.UAE  ? "Select Emirates" :'Select City'}`}
                            options={cities.options}
                            onChange={cityChangeHandler}
                            getOptionLabel={x => x.name}
                            getOptionValue={x => x.id}
                        />
                        {cities.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{cities.error}</small>}
                    </div>
                </div>
            </div>

            {showOtherCity ||  cities.value?.id === 0 ?
            <div className="col-md-6 mb-3">
                <label  className="form-label">Other City<span>*</span></label>
                <input type="text" 
                disabled={!showOtherCity}  
                value={otherCity.value} 
                onChange={e => {
                    let value = e.target.value
                    value = value.replace(/[^A-Za-z- ]/ig, '') 
                    setOtherCity({...otherCity,value:value,error:''})
                    }
                }  
                className="form-control"  placeholder="Enter Your City Name..."/>
                {otherCity?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{otherCity.error}</small>}
            </div>
            :''}
            

            <div className="col-md-6 mb-3">
                <label className="form-label">Class<span>*</span></label>
                <Select
                className='search-select-dropdown'
                name="classes"
                value={classes.value!==null?classes.value:''}
                placeholder='Select Classes'
                options={classes.options}
                isDisabled={is_paid ===1 || paid_status===1}
                onChange={handleClassChange}
                getOptionLabel={x => x.name}
                getOptionValue={x => x.id}
                />
                {classes?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{classes.error}</small>}
            </div>

        
         
            

            <div className="col-md-6 mb-3">
                <label className="form-label">Study Center<span>*</span></label>
                <Select
                    className='search-select-dropdown'
                    name="studyCenter"
                    value={studyCenter.value}
                    placeholder='Select Study Center'
                    options={studyCenter.options}
                    isDisabled={is_paid ===1 || paid_status===1}
                    onChange={handleStudyCenterChange}
                    getOptionLabel={x => x.name}
                    getOptionValue={x => x.id}
                />
                {studyCenter.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{studyCenter.error}</small>}

            </div>

            <div className="col-md-6 mb-3">
                <label className="form-label">Course<span>*</span></label>
                <Select
                    className='search-select-dropdown'
                    name="courses"
                    value={courses.value}
                    placeholder='Select Course'
                    options={courses.options}
                    isDisabled={is_paid ===1 || paid_status===1}
                    onChange={handleCoursesChange}
                    getOptionLabel={x => x.name}
                    getOptionValue={x => x.id}
                    />
                    {courses?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{courses.error}</small>}

            </div>

            <div className="col-md-6 mb-3">
                <label className="form-label">Study Curriculum<span>*</span></label>
                <Select
                    className='search-select-dropdown'
                    name="curriculums"
                    value={selectedCurriculum.value!==null ?selectedCurriculum.value:''}
                    placeholder='Select Curriculum'
                   
                    options={selectedCurriculum.options}
                    onChange={handleCurriculumChange}
                    getOptionLabel={x => x.name}
                    getOptionValue={x => x.id}
                />
                {selectedCurriculum?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{selectedCurriculum.error}</small>}

            </div>

            {(showOtherCurriculum ||  selectedCurriculum.value?.name == 'OTHER' || selectedCurriculum.value?.name == 'OTHERS') ?
            <div className="col-md-6 mb-3">
                <label  className="form-label">Curriculum Name<span>*</span></label>
                <input type="text" 
                disabled={showOtherCurriculum !==undefined && showOtherCurriculum !==true}  
                value={otherCurriculum.value} 
                onChange={e => {
                    let value = e.target.value
                    value = value.replace(/[^A-Za-z- ]/ig, '') 
                    setOtherCurriculum({...otherCurriculum,value:value,error:''})
                    }
                }  
                className="form-control"  placeholder="Enter Curriculum Name..."/>
                {otherCurriculum?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{otherCurriculum.error}</small>}
            </div>
            :''}

            <div className="col-md-6 mb-3">
                <label className="form-label">School<span>*</span></label>
                <Select
                    className='search-select-dropdown'
                    name="schools"
                    value={schools.value!==null?schools.value:''}
                    placeholder='Select school'
                    options={schools.options}
                    // isDisabled={is_paid===1 || paid_status===1}
                    onChange={handleSchoolChange}
                    getOptionLabel={x => x.name}
                    getOptionValue={x => x.id}
                />
                {schools.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{schools.error}</small>}

            </div>

            {isOtherSchool || schools.value?.id === 0 ? 
            <div className="col-md-6 mb-3">
                <label className="form-label">Other School Name<span>*</span></label>
                <input
                type="text"
                className="form-control"
                name="otherSchoolName"
                placeholder="Other School Name"
                value={otherSchoolName.value!==null?otherSchoolName.value:'' }
                disabled={!isOtherSchool}
                onChange={(e) => setOtherSchoolName({ ...otherSchoolName, value: e.target.value, error: '' })}
            />
                {otherSchoolName?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{otherSchoolName.error}</small>}

            </div>
            :''}
                {country.value.id ==4 && 
                <div className="col-md-6 mb-3">
                    <label className="form-label">Batch Preference<span>*</span></label>
                    <select disabled={(userDetail?.batch_preference !==null && userDetail?.batch_preference !=='') && (is_paid===1 || paid_status===1)} className="form-control" value={batchPreference.value ||''} onChange={e => setBatchPreference({...batchPreference,value:e.target.value,error:''})}>
                        <option value="">Select batch</option>
                        <option value="Weekend Batch">Weekend Batch</option>
                        {classes.value.id !==3 && 
                            <option value="Weekday Batch">Weekday Batch</option>
                        }
                    </select>
                    {batchPreference?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{batchPreference.error}</small>}

                </div>
                }


                {/* {(country.value.id ===1 || country.value.id ===5 || country.value.id ===7 ) && 
                <div className="col-md-6 mb-3">
                <label className="form-label"><b>Batch Options</b> (To view batch details, please select an option. Once a batch is selected and saved, it cannot be changed.)<span>*</span></label>
                <Select
                className='search-select-dropdown'
                name="Batch Options"
                value={batchOption.value!==null?batchOption.value:''}
                placeholder='Select Batch Option'
                options={batchOption.options}
                isDisabled={(userDetail?.batch_option_id !==null && userDetail?.batch_option_id !=='') && (is_paid===1 || paid_status===1)}
                onChange={handleBatchOptionChange}
                getOptionLabel={x => x.name}
                getOptionValue={x => x.id}
                />
                {batchOption?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{batchOption.error}</small>}
            </div>
                } */}
            
            {/* {(country.value.id ===2 ) && 
                <>
                {(classes.value.id ===1 || classes.value.id ===2 || classes.value.id ===3 ) && 
                    <div className="col-md-6 mb-3">
                        <label className="form-label"><b>Batch Options</b> (To view batch details, please select an option. Once a batch is selected and saved, it cannot be changed.)<span>*</span></label>
                        <Select
                        className='search-select-dropdown'
                        name="Batch Options"
                        value={batchOption.value!==null?batchOption.value:''}
                        placeholder='Select Batch Option'
                        options={batchOption.options}
                        isDisabled={(userDetail?.batch_option_id !==null && userDetail?.batch_option_id !=='') && (is_paid===1 || paid_status===1)}
                        onChange={handleBatchOptionChange}
                        getOptionLabel={x => x.name}
                        getOptionValue={x => x.id}
                        />
                        {batchOption?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{batchOption.error}</small>}
                    </div>
                }
                </>
            } */}

            {(country.value.id ===1 || country.value.id ===2 || country.value.id ===5 || country.value.id ===7 || country.value.id ===4) && 
                <>
                {(classes.value.id ===1 || classes.value.id ===2) && 
                    <div className="col-md-6 mb-3">
                       
                        <label className="form-label"><b>Batch Options</b> (To view batch details, please select an option. Once a batch is selected and saved, it cannot be changed.)<span>*</span></label>
                        <Select
                        className='search-select-dropdown'
                        name="Batch Options"
                        value={batchOption.value!==null?batchOption.value:''}
                        placeholder='Select Batch Option'
                        options={batchOption.options}

                        isDisabled={(userDetail?.batch_option_id !==null && userDetail?.batch_option_id !=='') && (is_paid===1 || paid_status===1)}
                        onChange={handleBatchOptionChange}
                        getOptionLabel={x => x.name}
                        getOptionValue={x => x.id}
                        />
                        {batchOption?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{batchOption.error}</small>}
                    </div>
                }
                </>
            }

            <div className="w-100"></div>
            {batchOption.value && (
            <div className="col-md-6 mb-3 ">
                <div className='batch_option_detail'>
                <h5>Days : {batchOption.value?.days}</h5>
                <h4>Course commence date {batchOption.value?.course_commencement_date}</h4>
                <div className='batch_descriptoin' dangerouslySetInnerHTML={{ __html: batchOption.value?.description }} ></div>
                </div>
            </div>
            )}

            <div className="col-md-12 mb-3 mt-2">
            {loading ? <button className="btn btn-default" disabled type="button">
                    <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                        Updating...</button>:<button type="submit" className="btn btn-default">Save & Next</button>}
                {/* <button className="btn btn-default ms-2" onClick={e => nexTabChange()} type="button">Next</button> */}
            </div>                            
        </div>
    </form>
  )
}

export default EnrollmentDetailForm